import ErrorPage from '../components/ErrorPage';

export default function NotFound() {
  return (
    <ErrorPage
      icon="🤔"
      title="页面不存在"
      message="你访问的页面找不到。"
      fullscreenGradient={false}
    />
  );
}
